import React from 'react';
import * as yup from 'yup';
import FormSection from '../../../common/hookFormComponents/FormSection';

const fields = [
  {
    colSpan: 1,
    name: 'annualProdCapacity',
    type: 'text',
    label: 'Annual Production/Manufacturing Capacity',
    isRequired: true,
  },
  {
    colSpan: 3,
    name: 'suppliedTo',
    type: 'text',
    label: 'Buyer',
    placeholder: 'Name & Address of the Mill',
    isRequired: true,
  },
];

export const millInfoFieldsValidation = {
  [fields[0].name]: yup.string().required().label(fields[0].label),
  [fields[1].name]: yup.string().required().label(fields[1].label),
};

const MillInformationSection = (props) => {
  return (
    <FormSection sectionName="Mill Information" sectionColumn={4} formFields={fields} {...props} />
  );
};

export default MillInformationSection;
